import { useTranslation } from 'react-i18next';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useQuery } from '@tanstack/react-query';
import { ListNamesDictionary, getMerchantRules } from 'Services';
import { RQ_MERCHANT_RULES } from 'Utils';
import { transformServerData } from '../helper';

type Props = {
    merchantId: string;
    users?: UsersHashmap;
    enabled?: boolean;
    listNameMap?: ListNamesDictionary;
    parameterData?: UseGetParametersResponse;
};

const useMerchantRules = ({ merchantId, users, enabled, listNameMap, parameterData }: Props) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_MERCHANT_RULES, templateRepositoryId, merchantId],
        () => getMerchantRules(templateRepositoryId!, merchantId),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0) && enabled !== false,
            select: transformServerData({ t, users, listNameMap, parameterData })
        }
    );
};

export default useMerchantRules;
